import { PhaseTypes } from '../Store/utils';

export const PHASE_TYPES: PhaseTypes[] = Object.values(PhaseTypes) as PhaseTypes[];

export function getProjectPhaseDescription(phases?: PhaseTypes[]) {
  if (!phases || phases.length === 0) {
    return 'Alla faser';
  }

  const total = PHASE_TYPES.length;

  if (phases.length === total) {
    return 'Alla faser';
  }

  if (phases.length === total - 1) {
    const missing = PHASE_TYPES.filter((p) => !phases.includes(p));

    return `Ej ${missing[0].toLowerCase()}`;
  }

  return capitalize(formatList(phases).toLowerCase());
}

function formatList(values: string[]) {
  if (values.length <= 1) return values.join('');
  return `${values.slice(0, -1).join(', ')} och ${values.at(-1)}`;
}

function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
